import { Cell, Pie, PieChart } from 'recharts'

interface ProgressCircleProps {
  progress: number
  color: string
}
export const ProgressCircle = ({ progress, color }: ProgressCircleProps) => {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        flexShrink: 0,
      }}
    >
      <span
        style={{
          fontSize: 12,
          lineHeight: 1,
          minWidth: '2.75rem',
          textAlign: 'right',
          fontVariantNumeric: 'tabular-nums',
        }}
      >
        {progress}%
      </span>
      <PieChart width={44} height={35}>
        <Pie
          cx="50%"
          cy="50%"
          data={[{ value: progress }, { value: 100 - progress }]}
          dataKey="value"
          innerRadius={10}
          fill="#E2E8F0"
          outerRadius={15}
        >
          <Cell fill={color} />
          <Cell fill="#E2E8F0" />
        </Pie>
      </PieChart>
    </div>
  )
}
